
import { useRouter, useRoute } from 'vue-router'
import { message } from 'ant-design-vue'
import { PermissionMap } from '@/utils/auth'
import { computed, onBeforeMount, reactive, ref } from 'vue'
import { debounce } from '@/utils/common'
import {
  getSheetSongVersions,
  deleteSheetSongVersion,
  setSheetVersionProduction,
  setSheetVersionTest,
  setSheetVersionDevelop
} from '@/services/songs'
import ResourceVersionTag from '@/components/common/ResourceVersionTag'

export default {
  name: 'VersionList',
  components: {
    ResourceVersionTag
  },
  setup () {
    const router = useRouter()
    const route = useRoute()
    const pageData = reactive({
      type: 1,
      firstLoading: true,
      advanced: false,
      tagParams: {
        pageSize: 50,
        page: 1,
        keyword: ''
      },
      modalVisible: false
    })
    const tableState = reactive({
      data: [],
      columns: [],
      loading: true,
      pagination: {
        current: 1,
        total: 1,
        pageSize: 10,
        showTotal: total => `共${total}条`,
        showQuickJumper: true
      }
    })
    tableState.columns = [
      {
        title: 'ID',
        dataIndex: 'id',
        width: 120
      },
      {
        title: '歌曲名称',
        dataIndex: 'name',
        ellipsis: true,
        width: 200
      },
      {
        title: '歌曲识别码',
        dataIndex: 'song_code',
        width: 140
      },
      {
        title: '歌曲简拼',
        dataIndex: 'py',
        width: 100,
        ellipsis: true
      },
      {
        title: '版本类型',
        dataIndex: 'version_type',
        width: 200,
        slots: { customRender: 'version_type' }
      },
      {
        title: '创建时间',
        dataIndex: 'created_at',
        width: 180,
        ellipsis: true
      },
      {
        title: '更新时间',
        dataIndex: 'updated_at',
        width: 180,
        ellipsis: true
      },
      {
        title: '操作',
        key: 'action',
        fixed: 'right',
        width: 440,
        slots: { customRender: 'action' }
      }
    ]

    const getList = debounce(async (params) => {
      tableState.loading = true
      params = { page: 1, ...params, sheet_song_id: route.params.id }
      const { items, pagination } = await getSheetSongVersions(params)
      tableState.data = items
      tableState.loading = false
      tableState.pagination = { ...tableState.pagination, ...pagination }
    })
    const handleBack = () => {
      history.go(-1)
    }
    const handleJumpInfo = (record) => {
      router.push(`/resource/sheet-songs/${route.params.id}/version-detail/${record.id}`)
    }
    const handleTableChange = (pag) => {
      tableState.pagination = pag
      getList({ page: tableState.pagination.current })
    }
    const handleCreate = () => {
      router.push(`/resource/sheet-songs/${route.params.id}/edit/${pageData.type}`)
    }
    const handleSetOfficial = async (record) => {
      await setSheetVersionProduction(record.id)
      message.success('操作成功')
      getList()
    }
    const handleSetTest = async (record) => {
      await setSheetVersionTest(record.id)
      message.success('操作成功')
      getList()
    }
    const handleSetDev = async (record) => {
      await setSheetVersionDevelop(record.id)
      message.success('操作成功')
      getList()
    }
    const handleDelete = async (record) => {
      await deleteSheetSongVersion(record.id)
      message.success('操作成功')
      getList()
    }

    onBeforeMount(async () => {
      await Promise.all([
        getList()
      ])
      pageData.firstLoading = false
    })

    return {
      tableState,
      pageData,
      PermissionMap,
      handleJumpInfo,
      handleBack,
      handleTableChange,
      handleCreate,
      handleSetOfficial,
      handleSetTest,
      handleDelete,
      handleSetDev
    }
  }
}
